var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 27,
    viewBox: "0 0 77 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 27,
    rx: 8,
    fill: "url(#paint0_linear_2614_1749)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 13.5L9.5 5.70577L9.5 21.2942L23 13.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7969 21V6.72266H33.8242V18.5H39.6152V21H30.7969ZM42.1055 21V6.72266H45.1328V21H42.1055ZM56.8711 6.72266H59.9277L55.0742 21H51.7734L46.9297 6.72266H49.9863L52.6719 15.2188C52.8216 15.7201 52.9746 16.306 53.1309 16.9766C53.2936 17.6406 53.3945 18.1029 53.4336 18.3633C53.5052 17.7643 53.7493 16.7161 54.166 15.2188L56.8711 6.72266ZM69.957 21H61.7344V6.72266H69.957V9.20312H64.7617V12.3379H69.5957V14.8184H64.7617V18.5H69.957V21Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2614_1749",
    x1: 6.90067e-7,
    y1: 15.4691,
    x2: 76.9937,
    y2: 14.6175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65DF46"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0094FF"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC4EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502295,
    stopColor: "#FF4A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB200"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveIcon);
export default __webpack_public_path__ + "static/media/live_icon.e87a9c8a5c252c4c0df8edb18ef69678.svg";
export { ForwardRef as ReactComponent };